import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboAcaoAtividadeComponent } from './combo-acao-atividade.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboAcaoAtividadeComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboAcaoAtividadeComponent]
})
export class ComboAcaoAtividadeModule { }
